import { render, staticRenderFns } from "./PassengerForm.vue?vue&type=template&id=ce8f6f26&scoped=true&"
import script from "./PassengerForm.vue?vue&type=script&lang=ts&"
export * from "./PassengerForm.vue?vue&type=script&lang=ts&"
import style0 from "./PassengerForm.vue?vue&type=style&index=0&id=ce8f6f26&lang=scss&scoped=true&"
import style1 from "./PassengerForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8f6f26",
  null
  
)

export default component.exports